import { Component, OnInit } from '@angular/core';
import { GalleryService } from './../services/gallery.service';
import { AppConfig } from './../config/app-config';
import { FileSection, FileType, FileData } from './../models/fileData';
import { Observable, Observer } from 'rxjs';

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare let refreshCarousel: any;

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html'
})
export class GalleryComponent implements OnInit {

  constructor(
    public modalService: NgbModal,
    private galleryService: GalleryService,
    private appConfig: AppConfig) {
  }

  //galleryImagesModalIsOpen: boolean = false;

  page = 1;
  pageSize = 12;
  collectionSize = 0;

  AllGalleries: any[] = [];
  GalleryCategories$: any[] = [];
  Galleries$: any[] = [];
  Years$: any[] = [];

  //selectedCategory$ = "";
  //selectedYear$ = "";
  selectedCategory$ = 0;
  selectedYear$ = 0;

  SliderImages$: any[] = [];

  ngOnInit() {

  }

  getGalleryCategoriesList() {
    this.galleryService.getGalleryCategoriesList().subscribe((response) => {
      this.GalleryCategories$ = response as any[];
    }, (error) => {
      console.log(error);
    });
  }

  getGalleriesList() {
    this.galleryService.getGalleriesList().subscribe((response) => {

      this.AllGalleries = response as any[];
      this.Galleries$ = this.AllGalleries;
      this.collectionSize = this.Galleries$.length;

      return response
        .map((gal, i) => ({ id: i + 1, ...gal }))
        .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }, (error) => {
      console.log(error);
    });
    return null;
  }

  getYearList() {
    let currYear = new Date().getFullYear();
    let startYear: number = currYear - 5;
    let endYear: number = currYear;

    for (let i = startYear; i <= endYear; i++) {
      this.Years$.push(i);
    }
  }

  ngAfterContentInit() {
    this.getGalleryCategoriesList();
    this.getGalleriesList();
    this.getYearList();
  }

  applyFilters() {

    this.Galleries$ = this.AllGalleries;

    let result = [];

    
    if (this.selectedCategory$ > 0 && this.selectedYear$ > 0) {
      const filteredData = this.AllGalleries.filter(x => x.categoryId == this.selectedCategory$ && x.year == this.selectedYear$);
      result.push(filteredData);
    }
    else if (this.selectedCategory$ > 0) {
      //category search
      const filteredData = this.AllGalleries.filter(x => x.categoryId == this.selectedCategory$);
      result.push(filteredData);
    } else if (this.selectedYear$ > 0) {
      const filteredData = this.AllGalleries.filter(x => x.year == this.selectedYear$);
      result.push(filteredData);
    }
    
    if (result.length > 0) {
      let final = [];

      //combine result into one final array
      result.forEach(function (val, ind, arr) {
        final.push(val);
      });

      //remove duplicates from final array
      const unique = final.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });

      this.Galleries$ = unique[0];
    }

    if (this.Galleries$.length === 0) {
      this.Galleries$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.Galleries$.length;
    }

  }

  resetSearch() {
    this.selectedCategory$ = 0;
    this.selectedYear$ = 0;
    this.Galleries$ = this.AllGalleries;
    this.collectionSize = this.Galleries$.length;
  }

  viewGallery(linkedId, contentModal) {
    this.SliderImages$ = [];
    this.getImages(linkedId);
    //this.openModal(true);
    this.modalService.open(contentModal, { centered: true, size: 'lg' });

    setTimeout(function () {
      try {

        refreshCarousel();
      } catch (e) {
        console.log(e.message);
      }

    }, 2000);
  }

  getImages(linkedId) {
    this.galleryService.getImages(linkedId).subscribe((response) => {
      response.forEach((val, idx, arr) => {
        this.buildImageUrl(this.appConfig.baseUrl + '/Uploads/' + FileSection[val.fileSection] + '/' + FileType[val.fileType] + '/' + val.linkedId + '/' + val.physicalFileName);
      });
    }, (error) => {
      console.log(error);
    });
  }

  buildImageUrl(fileLocation) {
    this.getBase64ImageFromURL(fileLocation).subscribe((res) => {
      this.SliderImages$.push('data:image/png;base64,' + res);
    });
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  //openModal(open: boolean): void {
  //  //this.galleryImagesModalIsOpen = open;
  //  this.modalService.open("#content", { centered: true });
  //}

}
